<template>
    <div>
        <b-row>
            <b-col cols="8">
                <b-card no-body >
                    <template #header>
                        <div class="d-flex">
                            <b-button @click="$router.back()" size="sm" variant="outline-secondary" class="me-2">
                                <i class="fas fa-arrow-left"></i>
                            </b-button>
                            <strong class="pt-1">
                                View Document
                            </strong>
                        </div>
                    </template>
                    <div class="bg-dark">

                    
                        <div v-if="hasMounted">
                            <uploader  v-show="false" :autoStart="true" :ref="'doc_uploader'" :options="renderUploadOptions" class="uploader-example">
                                <uploader-unsupport></uploader-unsupport>
                                <uploader-drop style="background-color:rgb(237 255 239);">
                                    <b-row>
                                        <b-col cols="7">
                                            <p style="margin-top: 5px ;margin-bottom: 0;">Drop files here to upload or</p>
                                        </b-col>
                                        <b-col cols="5">
                                            <uploader-btn style="margin-bottom: 0;">Select file</uploader-btn>
                                        </b-col>
                                    </b-row>
                                </uploader-drop>
                                <uploader-list></uploader-list>
                            </uploader>
                        </div>
                        <annotate-pdf
                        v-if="b64 != null && show_document"
                        :sign_mode="enable_sign_mode"
                        @progress="setProgress"
                        @saveSignedPDF="handleSavePDF"
                        :signature_svg="client_signatures"
                        :base64="b64"/>
                        <b-alert v-else show>Waiting for document data</b-alert>
                    </div>
                    
                </b-card>
            </b-col>

            <b-col cols="4">
                <!-- <b-card>
                    <b-button size="lg" @click="$bvModal.show('notesModal');" variant="outline-success">
                        <i class="fas fa-comment"></i>
                    </b-button>
                    &nbsp;
                    <b-button size="lg" @click="showRequestModal" variant="outline-success">
                        <i class="fas fa-envelope"></i>
                    </b-button>
                </b-card> -->

                <b-card title="SOP Info">
                    <div v-if="sop_data != null">
                        <p>
                            <strong>SOP Code:</strong>&nbsp;
                            {{ sop_data.sop_code }}
                        </p>
                        <p>
                            <strong>SOP Group:</strong>&nbsp;
                            {{ sop_data.client_s_o_p_group.name }}
                        </p>
                        <p>
                            <strong>SOP Name:</strong>&nbsp;
                            {{ sop_data.name }}
                        </p>
                        <p v-if="revision_data != null">
                            <strong>Revision No:</strong>&nbsp;
                            {{ revision_data.client_revision_no }}
                        </p>
                        <p v-if="revision_data != null">
                            <strong>Date Released:</strong>&nbsp;
                            {{ revision_data.effective_date }}
                        </p>
                    </div>
                </b-card>
                <!-- ************ -->
                <!-- <b-card title="Notes">

                </b-card>
                
                <b-card v-if="is_actionable_view">
                    <b-row>
                        <b-col cols="12">
                            <b-button :disabled="scroll_progress > 90 ? false : true" variant="primary" size="lg" @click="readDoc" >
                                Read</b-button>
                            &nbsp;
                            <b-button variant="danger" size="lg" @click="flagDoc">
                                Flag</b-button>
                        </b-col>
                    </b-row>
                </b-card> -->
            </b-col>
        </b-row>
        <b-modal hide-footer title="Comment" id="notesModal">
            <div class="modal-body">
                <b-form>
                    <b-form-group class="mb-4" label="Comment: " label-for="comment" label-cols-sm="3">
                        <b-form-input
                            id="comment"
                            type="text"
                            v-model="new_comment_text"
                        ></b-form-input>
                    </b-form-group>
                </b-form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary">Save</button>
                <button type="button" class="btn btn-secondary">Close</button>
            </div>
        </b-modal>
        <RequestModal
        v-if="show_request_modal"
        :client_revision_id="revision_data.client_revision_id"/>
    </div>
</template>

<script>
import pdfMixin from '@/mixins/pdfMixin.js'
import RequestModal from './modals/requestUnauthorisedModal.vue'
import Swal from 'sweetalert2'
//import Uploader from 'simple-uploader.js'
import _ from 'lodash';
import { sopState, sopMethods, layoutMethods, userState, userMethods} from '@/state/helpers.js'
export default {
    mixins: [ pdfMixin ],
    data:() => ({
        is_uploading: false,
        b64: null,
        show_document: null,
        revision_data: null,
        scroll_progress: 0,
        hasMounted: false,
        new_comment_text: '',

        show_request_modal: false,
    }),
    components:{
        RequestModal,
    },
    watch:{
        hasMounted(){

        }
    },
    props:{
        //* show the 'Read' and 'Flag' buttons if true
        is_actionable_view:{
            default: true
        }
    },
    computed:{
        ...sopState,
        ...userState,
        sop_revisions(){
            if(this.sop_data != null){
                return this.sop_data.client_revisions;
            }
            else{
                return [];
            }
        },
        enable_sign_mode(){
            return this.active_job_data.id == this.$route.params.document_id && this.active_job_data.sign_mode;
        },
        client_signatures(){
            let signatures = {
                signature: null,
                initial: null,

            }
            if(this.client_signature != null){
                signatures.signature = this.client_signature.signature_svg;
            }
            if(this.client_initial != null){
                signatures.initial = this.client_initial.signature_svg;
            }
            console.table(signatures);
            return signatures;
        },
        renderUploadOptions() {
            let params = {
                client_revision_id: this.active_job_data.revision_id,
                job_id : this.active_job_data.job_id,
            }
            var url = process.env.VUE_APP_API_BASEURL + 'api/clientdocadmin/uploadsignedsop';
            var options = {
                target: url,
                query: params,
                testChunks: false,
                simultaneousUploads: 1, 
                fileParameterName: 'signed_sop', //Set the upload post param which will contain the binary payload
                singleFile: true, //Limit upload to one file
            }
            return options;
        },
    },
    methods:{
        ...userMethods,
        ...layoutMethods,
        ...sopMethods,
        initUploaderEvents(){
            let el = this;
            this.$refs.doc_uploader.uploader.on('fileError', function () {
                el.is_loading = false;
            })
            this.$refs.doc_uploader.uploader.on('uploadStart', function () {
                el.is_loading = true;
            })
            this.$refs.doc_uploader.uploader.on('complete', function () {
                el.is_loading = false;
                el.$eventHub.$emit('refreshRevisions')
            })
        },
        handleSavePDF(blob){
            //* Get uploader component
            let el = this;
            const uploaderInstance = this.$refs['doc_uploader'];
            const upload = uploaderInstance.uploader;
            this.is_uploading = true;

            //* create file object
            const AUTH_TOKEN = window.localStorage.getItem('x_token');
            upload.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                'Authorization': 'Bearer ' + AUTH_TOKEN,
            };
            let file = new File([blob], 'sop_blob');
            upload.addFile(file);
            upload.resume();
            //eslint-disable-next-line no-unused-vars
            upload.on('fileSuccess', (rootFile, file, message, chunk)=>{
                var response = JSON.parse(message);
                if(response.success){
                    Swal.fire("Uploaded", "SOP Approved!", "success");
                    upload.off("fileSuccess");
                    upload.cancel();
                    el.setActiveJobInfo({});
                    el.loadNotifications();
                    el.$router.back();
                }
                else {
                   //eslint-disable-next-line no-console
                    console.log("Upload error");
                }
            });
        },
        findPublishedRevision(){
            let index = _.findIndex(this.sop_revisions, {published: 1});
            if(index != -1){
                this.selectRevision(index);
            }
            else{
                this.$nextTick(()=>{
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'This document has not been published yet!',
                    })
                    .then(()=>{
                        this.$router.push({ name: 'documents' });
                    })
                })
            }
        },
        loadPdfB64(){
            //Load pdf b64 of latest revision
            this.b64 = null;
            //* if signing a doc, need to pull revision id from active_job_data
            let revision_id = this.enable_sign_mode ? this.active_job_data.revision_id : this.revision_data.client_revision_id
            window.axios({
                url: 'api/clientdocadmin/b64preview/' + revision_id,
                method: 'GET',
                responseType: 'blob',
            })
            .then( async (response) =>{
                const response_data = response.data;
                //* process the pdf using the helper method from pdfMixin.js
                this.b64 = await this.processPdfBlob(response_data);
                this.show_document = true;
            })
        },
        selectRevision(index){
            this.revision_data = _.cloneDeep(this.sop_revisions[index]);
            this.selected_revision_index = index;
            
            this.hasMounted = true;

            console.log('DDEBUG', this.revision_data)

            this.loadPdfB64();



            //this.getPreviewB64(this.revision_data.client_revision_id)
            //.then( data => {
            //    this.b64 = data;
            //    this.show_document = true;
            //    //if(data.pdf_64 != undefined){
            //    //    this.b64 = data.pdf_64;
            //    //    this.show_document = true;
            //    //}
            //})
        },
        setProgress(progress){
            if(progress > this.scroll_progress){
                this.scroll_progress = progress;
            }
        },
        flagDoc(){
            let params = {
                "actionable_id": this.action_id,
                "complete":false,
                "flagged":true,
                "notes":null
            }
            this.setDocumentFlag(params)
            .then(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'red',
                    icon: 'error',
                    title:'Flagged document.',
                    customClass: {     popup: 'warning-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                });
                this.loadNotifications();
            })
        },
        readDoc(){
            let params = {
                "actionable_id": this.action_id,
                "complete":true,
                "flagged":false,
                "notes":null
            }
            this.setDocumentFlag(params)
            .then(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'white',
                    icon: 'success',
                    title:'Marked as read.',
                    customClass: {     popup: 'success-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                });
                this.loadNotifications();
            })
        },
        //* modal stuff **/
        showRequestModal(){
            this.show_request_modal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('requestsModal');
                this.$root.$once('bv::modal::hidden',(event)=>{
                    if(event.type == 'hidden' && event.componentId == 'requestsModal'){
                        this.show_request_modal = false;
                    }
                })
            })
        }
    },
    mounted(){
        //this.clearSopStore();
        if(this.$route.params.document_id){
            this.loadSopData(this.$route.params.document_id)
            .then(()=>{
                if(this.enable_sign_mode){
                    this.hasMounted = true;
                    this.loadPdfB64();
                }
                else{
                    this.findPublishedRevision();
                }

            })
            .catch(()=>{
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Document does not exist!',
                })
                .then(()=>{
                    this.$router.push({ name: 'documents' });
                })
            })
        }
        else{
            this.$router.back();
        }

        // load client signatures if null and sign mode is active
        if(this.enable_sign_mode && this.client_signature == null){
            // if signature is null, initial will probably be null. So load both
            this.loadClientSignature('signature');
            this.loadClientSignature('initial');
        }
        
    },

}
</script>

<style>
/*canvas{
    width: 100% !important;
}
.canvas-container{
    width: 100% !important;
}*/
</style>